import { useRef, forwardRef, RefObject } from 'react'

import classNames from 'classnames'

import { Box } from 'components/atomic'

import { TextAreaProps } from './types'

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      error,
      border,
      className,
      containerClassName,
      disabled,
      icon,
      onChange,
      placeholder,
      prefix,
      stretch,
      suffix,
      symbol,
      value,
      rows,
      ...restProps
    }: TextAreaProps,
    ref,
  ) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null)

    const focus = () => {
      const inputInstanceRef =
        (ref as RefObject<HTMLTextAreaElement>) || textareaRef
      inputInstanceRef?.current?.focus?.()
    }

    return (
      <Box className={classNames(stretch ? 'w-full' : 'w-fit')} col>
        <Box
          className={classNames(
            'flex flex-row py-2.5 transition-all',
            'border-light-border-primary focus-within:border-dark-typo-gray dark:border-dark-border hover:border-dark-typo-gray dark:hover:border-dark-typo-gray dark:focus-within:border-dark-typo-gray',
            border ? 'border-solid' : 'border-none',
            stretch ? 'w-full' : 'w-fit',
            {
              'px-2 border rounded-2xl': border === 'rounded',
              'border-0 border-b': border === 'bottom',
            },
            containerClassName,
          )}
          onClick={focus}
          alignCenter
        >
          <textarea
            disabled={disabled}
            ref={ref || textareaRef}
            rows={rows}
            className={classNames(
              'font-primary bg-transparent dark:placeholder-dark-typo-gray dark:text-dark-typo-primary placeholder-light-typo-gray text-light-typo-primary transition-colors',
              'border-none font-normal text-[14px] focus:outline-none',
              stretch ? 'w-full' : 'md:w-52',
              { 'md:w-48': icon && !stretch, 'cursor-not-allowed': disabled },
              className,
            )}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            {...restProps}
          />
        </Box>
      </Box>
    )
  },
)
